import cls from "./BlogCaseCard.module.css";
import Link from "next/link";
import type { ReactNode } from "react";
import { ResultArrowIcon } from "@/utils/images/Blog";

interface BlogCaseCardProps {
    title: string;
    /** Starting point of the project, shown in neutral text. */
    from: string;
    /** Where it landed — tinted with the card tone. */
    to: string;
    text: ReactNode;
    tone?: "green" | "red";
    href?: string;
    linkText?: string;
}

export const BlogCaseCard = ({ title, from, to, text, tone = "green", href, linkText = "Read the case study →" }: BlogCaseCardProps) => {
    return (
        <div className={`${cls.card} ${tone === "red" ? cls.red : cls.green}`}>
            <div className={cls.head}>
                <span className={cls.title}>{title}</span>

                <span className={cls.result}>
                    <span className={cls.from}>{from}</span>
                    <span className={cls.arrow}><ResultArrowIcon /></span>
                    <span className={cls.to}>{to}</span>
                </span>
            </div>

            <p className={cls.text}>
                {text}
                {href && <> <Link className={cls.link} href={href}>{linkText}</Link></>}
            </p>
        </div>
    );
};
